export default "__VITE_ASSET__CSh55EDP__"